/* Keep the same reading position through Shopify's native customer form POST.
   Only geometry is stored; Shopify retains form submission and CAPTCHA handling. */
(() => {
  const key = 'cc-newsletter-return';
  const scroller = () => document.querySelector('.page-wrapper');
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.email-signup__form')) return;
    const wrapper = scroller();
    try {
      sessionStorage.setItem(key, JSON.stringify({
        path: location.pathname, form: form.id, time: Date.now(),
        wrapperY: wrapper?.scrollTop || 0, windowY: window.scrollY
      }));
    } catch {}
  }, true);
  let saved;
  try { saved = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch {}
  if (!saved || saved.path !== location.pathname || Date.now() - saved.time > 600000) return;
  const returned = new URLSearchParams(location.search).has('customer_posted') ||
    document.querySelector('.email-signup__message');
  if (!returned) return;
  const restore = () => {
    const wrapper = scroller();
    if (wrapper) wrapper.scrollTo({top: saved.wrapperY, behavior: 'instant'});
    window.scrollTo({top: saved.windowY, behavior: 'instant'});
  };
  const message = document.getElementById(saved.form)?.querySelector('.email-signup__message');
  if (message) message.setAttribute('role', 'status');
  if (location.hash === '#' + saved.form) {
    history.replaceState(history.state, '', location.pathname + location.search);
  }
  restore();
  requestAnimationFrame(() => requestAnimationFrame(restore));
  window.addEventListener('pageshow', () => { restore(); try { sessionStorage.removeItem(key); } catch {} }, {once:true});
})();
